export default "__VITE_ASSET__YnrK3fPx__"